import { createAsyncThunk } from '@reduxjs/toolkit';

export const getUnmappedCustomFieldsCount = createAsyncThunk(
  'salesChannels/getUnmappedCustomFieldsCount',
  async ({ salesChannelIds }, { extra: { sdk, Logger } }) => {
    try {
      const { data } = await sdk.setup.getUnmappedCustomFieldsCount({ salesChannelIds });
      return data;
    } catch (error) {
      Logger.error(
        new Error('Get unmapped custom fields count failed'),
        { error, salesChannelIds },
        ['PublishUnmappedFieldsCountFailed', {
          salesChannelIds: Array.isArray(salesChannelIds)
            ? salesChannelIds.map((id) => String(id)).join(',')
            : '',
        }],
      );
      throw error;
    }
  },
);
